import React from 'react'
import { TranslateIcon } from '@mote/assets/icons'
import type { MoteActionButtonProps } from '../MoteActionButton'
import { MoteActionButton } from '../MoteActionButton'
import type {
  TranscriptTranslationPickerProps,
  TranslationLanguage
} from '../TranscriptTranslationPicker'
import { TranscriptTranslationPicker } from '../TranscriptTranslationPicker'

export interface TranscriptTranslateButtonProps
  extends Omit<
      TranscriptTranslationPickerProps,
      'isOpen' | 'onClose' | 'onChange' | 'size'
    >,
    Pick<MoteActionButtonProps, 'textPosition' | 'size'> {
  onChange: (value: string) => void
  dialogSize?: TranscriptTranslationPickerProps['size']
}

export const TranscriptTranslateButton = (
  props: TranscriptTranslateButtonProps
): JSX.Element => {
  const { size, dialogSize, textPosition, ...rest } = props
  const [showPicker, setShowPicker] = React.useState(false)

  function handleOnChange(language: TranslationLanguage): void {
    props.onChange(language.code)
    setShowPicker(false)
  }

  return (
    <>
      <MoteActionButton
        text='Translate'
        icon={<TranslateIcon />}
        onClick={() => setShowPicker(true)}
        id='translate-mote-button'
        ariaLabel='Translate'
        size={size}
        textPosition={textPosition}
      />
      <TranscriptTranslationPicker
        isOpen={showPicker}
        onClose={() => setShowPicker(false)}
        {...rest}
        size={dialogSize}
        onChange={handleOnChange}
      />
    </>
  )
}
